import PlusCheckout from 'components/PlusCheckout';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import MinimalLayout from 'components/MinimalLayout';
import Plan from 'types/Plan';
import { useEffect } from 'react';
import logProCheckoutPageViewed from '@alltrails/analytics/events/logProCheckoutPageViewed';
import ProUpsellFormat from '@alltrails/analytics/enums/ProUpsellFormat';
import * as styles from './CheckoutRoute.module.scss';

type Props = {
  annualPlan: Plan;
  coupon: Coupon;
  currencyCode: CurrencyCode;
  plans: Plan[];
  userId: number;
  whenExpired: string;
};

export default function CheckoutRoute({ annualPlan, coupon, currencyCode, plans, userId, whenExpired }: Props) {
  useEffect(() => {
    logProCheckoutPageViewed({ upsell_format: ProUpsellFormat.Standard });
  }, []);

  return (
    <MinimalLayout>
      <PlusCheckout
        annualPlan={annualPlan}
        className={styles.content}
        coupon={coupon}
        currencyCode={currencyCode}
        initialPlan={plans[0]}
        userId={userId}
        whenExpired={whenExpired}
      />
    </MinimalLayout>
  );
}
